import {
	NEXT,
	PREVIOUS,
	NEXT_JSONTREE_QUESTION,
	BACK_JSONTREE_QUESTION,
	TOGGLE_JSON_TREE,
	UPDATE_CURRENT_QUESTION_TREE_ID,
	GO_TO_NEXT_JSON_TREE,
	UPDATE_STATE,
	SET_ENTIRE_STATE,
	UPDATE_INCLUDED_CONTROLLER_QUESTIONS,
	ADD_EDITABLE_PARENT,
	UPDATE_LAST_ANSWERED_QUESTIONS,
	SAVE_CURRENT_QUESTION_TREE_ID,
	SET_LANGUAGE,
	SET_INITIAL_QUESTION_TREE,
	SET_MESSAGE,
} from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'
import { handleAddEditableParent } from './reducerFunctions/handleAddEditableParent.ts'
import { handleBackJsonTreeQuestion } from './reducerFunctions/handleBackJsonTreeQuestion.ts'
import { handleGoToNextJsonTree } from './reducerFunctions/handleGoToNextJsonTree.ts'
import { handleInitialQuestionTree } from './reducerFunctions/handleInitialQuestionTree.ts'
import { handleLanguage } from './reducerFunctions/handleLanguage.ts'
import { handleNext } from './reducerFunctions/handleNext.ts'
import { handleNextJsonTreeQuestion } from './reducerFunctions/handleNextJsonTreeQuestion.ts'
import { handlePrevious } from './reducerFunctions/handlePrevious.ts'
import { handleSaveCurrentQuestionTreeId } from './reducerFunctions/handleSaveCurrentQuestionTreeId.ts'
import { handleSetEntireState } from './reducerFunctions/handleSetEntireState.ts'
import { handleSetMessage } from './reducerFunctions/handleSetMessage.ts'
import { handleToggleJsonTree } from './reducerFunctions/handleToggleJsonTree.ts'
import { handleUpdateCurrentQuestionTreeId } from './reducerFunctions/handleUpdateCurrentQuestionTreeId.ts'
import { handleUpdateIncludedControllerQuestions } from './reducerFunctions/handleUpdateIncludedControllerQuestions.ts'
import { handleUpdateLastAnsweredQuestions } from './reducerFunctions/handleUpdateLastAnsweredQuestions.ts'
import { handleUpdateState } from './reducerFunctions/handleUpdateState.ts'

export function globalFormReducer<T>({
	state,
	action,
}: {
	state: State<T>
	action: Action<T>
}): State<T> {
	let simplifiedState: State<T> = state

	switch (action.type) {
		case NEXT:
			return handleNext(state, action)
		case PREVIOUS:
			return handlePrevious(state, action)
		case NEXT_JSONTREE_QUESTION:
			return handleNextJsonTreeQuestion(state, action)
		case BACK_JSONTREE_QUESTION:
			return handleBackJsonTreeQuestion(state, action)
		case GO_TO_NEXT_JSON_TREE:
			return handleGoToNextJsonTree(state, action)
		case TOGGLE_JSON_TREE:
			return handleToggleJsonTree(state, action)
		case UPDATE_CURRENT_QUESTION_TREE_ID:
			return handleUpdateCurrentQuestionTreeId(state, action)
		case SAVE_CURRENT_QUESTION_TREE_ID:
			return handleSaveCurrentQuestionTreeId(state, action)
		case UPDATE_STATE:
			return handleUpdateState(state, action)
		case SET_ENTIRE_STATE:
			return handleSetEntireState(simplifiedState, action)
		case UPDATE_LAST_ANSWERED_QUESTIONS:
			return handleUpdateLastAnsweredQuestions(state, action)
		case UPDATE_INCLUDED_CONTROLLER_QUESTIONS:
			return handleUpdateIncludedControllerQuestions(state, action)
		case ADD_EDITABLE_PARENT:
			return handleAddEditableParent(state, action)
		case SET_LANGUAGE:
			return handleLanguage(state, action)
		case SET_INITIAL_QUESTION_TREE:
			return handleInitialQuestionTree(state, action)
		case SET_MESSAGE:
			return handleSetMessage(state, action)
		default:
			return state
	}
}
